function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { shallowEqual, createMap } from '@bydesign-ui/utils';
export var TreeMapState;

(function (TreeMapState) {
  TreeMapState[TreeMapState["UNSELECTED"] = 0] = "UNSELECTED";
  TreeMapState[TreeMapState["PARTIAL"] = 1] = "PARTIAL";
  TreeMapState[TreeMapState["SELECTED"] = 2] = "SELECTED";
})(TreeMapState || (TreeMapState = {}));

export var TreeMapValue = function (_Emitter) {
  _inherits(TreeMapValue, _Emitter);

  var _super = _createSuper(TreeMapValue);

  function TreeMapValue(core) {
    var _this;

    _classCallCheck(this, TreeMapValue);

    _this = _super.call(this);
    _this.stateMap = {};
    _this.value = [];
    _this.particalCheck = true;
    _this.core = core;

    _this.resetHashState();

    return _this;
  }

  _createClass(TreeMapValue, [{
    key: "updateTreeMapValueOptions",
    value: function updateTreeMapValueOptions(options) {
      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = options.value,
          _options$particalChec = options.particalCheck,
          particalCheck = _options$particalChec === void 0 ? true : _options$particalChec;
      this.particalCheck = particalCheck;

      if (this.value !== value && !shallowEqual(this.value, value) || forceUpdate) {
        return !this.setValueToSelected(value);
      }

      return false;
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.resetHashState();
      this.value = [];
      this.emit('value-change', []);
    }
  }, {
    key: "clearSelected",
    value: function clearSelected() {
      var checkedStrategy = this.core.checkedStrategy;

      if (checkedStrategy === 'independent') {
        this.resetValue();
      } else {
        var rootId = this.core.getRootId();
        this.setItemState(rootId, TreeMapState.UNSELECTED, true);
      }
    }
  }, {
    key: "resetValueToSelected",
    value: function resetValueToSelected() {
      this.setValueToSelected(this.value, true);
    }
  }, {
    key: "setItemState",
    value: function setItemState(id, newState) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var item = this.core.getItemInfo(id);

      if (item.disabled || item.readonly) {
        return false;
      }

      if (this.core.multiple) {
        var state = this.stateMap[id];
        newState = newState == null ? state === TreeMapState.SELECTED ? TreeMapState.UNSELECTED : TreeMapState.SELECTED : newState;
        this.updateSelectedState(id, newState, force);
      } else {
        this.resetHashState();
        this.updateSelectedState(id, TreeMapState.SELECTED, force);
      }

      this.value = this.getValueFromSelected();
      this.emitValueChange();
      return true;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getItemState",
    value: function getItemState(id) {
      return this.stateMap[id];
    }
  }, {
    key: "getIdFromSelected",
    value: function getIdFromSelected() {
      var _this2 = this;

      var _this$core = this.core,
          multiple = _this$core.multiple,
          spread = _this$core.spread;
      var hashMap = this.core.getHashMap();
      var result = Object.keys(hashMap).filter(function (key) {
        var _hashMap$key = hashMap[key],
            nodePath = _hashMap$key.nodePath,
            isLeaf = _hashMap$key.isLeaf,
            selectable = _hashMap$key.selectable;

        if (_this2.stateMap[key] !== TreeMapState.SELECTED) {
          return;
        }

        if (!_this2.core.association) {
          return true;
        }

        if (spread) {
          return isLeaf && selectable;
        }

        switch (_this2.core.checkedStrategy) {
          case 'parent':
            {
              for (var i = 1; i < nodePath.length - 1; i++) {
                if (_this2.stateMap[nodePath[i]] === TreeMapState.SELECTED && hashMap[nodePath[i]].selectable) {
                  return false;
                }
              }

              break;
            }

          case 'child':
            {
              return isLeaf && selectable;
            }

          case 'independent':
            {
              return true;
            }

          case 'all':
            {
              break;
            }
        }

        return nodePath.length > 1;
      });

      if (!multiple && result.length > 1) {
        console.error('TreeMap has multiple value, but is not multiple');
      }

      return result;
    }
  }, {
    key: "getSortedIdFromSelected",
    value: function getSortedIdFromSelected() {
      var _this3 = this;

      var selectedIds = this.getIdFromSelected();
      var valueIds = this.value.map(function (item) {
        return _this3.core.getIdByValue(item);
      });
      var selectedIdMap = createMap(selectedIds);
      var valueIdMap = createMap(valueIds);
      var ids = [];
      valueIds.forEach(function (id) {
        if (selectedIdMap[id]) {
          ids.push(id);
        }
      });
      selectedIds.forEach(function (id) {
        if (!valueIdMap[id]) {
          ids.push(id);
        }
      });
      return ids;
    }
  }, {
    key: "addLoadingItemState",
    value: function addLoadingItemState(items, parentState) {
      var _this4 = this;

      items.forEach(function (item) {
        _this4.stateMap[item.id] = parentState;

        _this4.addLoadingItemState(item.children || [], parentState);
      });
    }
  }, {
    key: "updateSelectedState",
    value: function updateSelectedState(id, state) {
      var _this5 = this;

      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var hashMap = this.core.getHashMap();

      if (state === TreeMapState.PARTIAL) {
        throw new Error('`state` could not be CHECKBOX_STATE_PARTIAL');
      }

      var pathNodes = hashMap[id].nodePath.map(function (item) {
        return hashMap[item];
      });
      var _this$core2 = this.core,
          association = _this$core2.association,
          multiple = _this$core2.multiple,
          independent = _this$core2.independent,
          checkedStrategy = _this$core2.checkedStrategy;

      if (!pathNodes.length) {
        return;
      }

      var current = pathNodes.pop() || null;

      if (!current || !force && state === this.stateMap[current.id]) {
        return;
      }

      this.setHashState(current.id, state, !current.isLeaf && association && multiple && checkedStrategy !== 'independent');

      if (!association || !multiple || independent || checkedStrategy === 'independent') {
        return;
      }

      var _loop = function _loop() {
        current = pathNodes.pop() || null;

        if (!current) {
          return {
            v: void 0
          };
        }

        var children = current.children || [];
        var length = children.length;
        var selected = 0;
        var unselected = 0;
        children.forEach(function (child) {
          var childState = _this5.stateMap[child.id];

          if (childState === TreeMapState.SELECTED) {
            selected++;
          } else if (childState === TreeMapState.UNSELECTED || childState == null) {
            unselected++;
          }
        });

        if (unselected === length) {
          _this5.setHashState(current.id, TreeMapState.UNSELECTED, false);
        } else if (selected === length) {
          _this5.setHashState(current.id, TreeMapState.SELECTED, false);
        } else {
          _this5.setHashState(current.id, _this5.particalCheck ? TreeMapState.PARTIAL : TreeMapState.UNSELECTED, false);
        }
      };

      while (pathNodes.length) {
        var _ret = _loop();

        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }, {
    key: "emitValueChange",
    value: function emitValueChange() {
      this.emit('value-change', this.value);
    }
  }, {
    key: "getValueFromSelected",
    value: function getValueFromSelected() {
      var _this6 = this;

      return this.getSortedIdFromSelected().map(function (item) {
        return _this6.core.getItemInfo(item).value;
      });
    }
  }, {
    key: "setValueToSelected",
    value: function setValueToSelected(value) {
      var _this7 = this;

      var isSilent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$core3 = this.core,
          multiple = _this$core3.multiple,
          spread = _this$core3.spread;

      if (!multiple && value.length > 1) {
        throw new Error('cascader is not multiple but has more than one value');
      }

      var unvalid = false;
      this.resetHashState();
      this.value = value;
      value.forEach(function (item) {
        var id = _this7.core.getIdByValue(item);

        var node = _this7.core.getItemInfo(id);

        if (!node) {
          unvalid = true;
          return;
        }

        if (spread && node.children && node.children.length) {
          unvalid = true;
          return;
        }

        _this7.updateSelectedState(id, TreeMapState.SELECTED);
      });

      if (unvalid) {
        this.emit('value-unvalid', value);
      }

      return unvalid;
    }
  }, {
    key: "resetHashState",
    value: function resetHashState() {
      var _this8 = this;

      var hashMap = this.core.getHashMap();
      this.stateMap = {};
      Object.keys(hashMap).forEach(function (id) {
        _this8.stateMap[id] = TreeMapState.UNSELECTED;
      });
    }
  }, {
    key: "setHashState",
    value: function setHashState(id, state) {
      var _this9 = this;

      var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (deep && state === TreeMapState.PARTIAL) {
        throw new Error('cant setStateAll partial');
      }

      var node = this.core.getItemInfo(id);

      if (!node) {
        throw new Error('cant setState for an inexistence item');
      }

      if (this.stateMap[id] === state) {
        return;
      }

      var disabled = node.disabled,
          readonly = node.readonly,
          value = node.value,
          nodePath = node.nodePath,
          _node$children = node.children,
          children = _node$children === void 0 ? [] : _node$children;

      if (!this.core.multiple) {
        this.stateMap[id] = state;

        if (deep) {
          children.forEach(function (item) {
            return _this9.setHashState(item.id, state, deep);
          });
        }

        return;
      }

      if (deep) {
        children.forEach(function (item) {
          return _this9.setHashState(item.id, state, deep);
        });
      }

      var _children$filter = children.filter(function (child) {
        return _this9.stateMap[child.id] === TreeMapState.SELECTED;
      }),
          checkdChildrenLength = _children$filter.length;

      var _children$filter2 = children.filter(function (child) {
        return _this9.stateMap[child.id] === TreeMapState.UNSELECTED;
      }),
          notCheckdChildrenLength = _children$filter2.length;

      if (children.length && this.core.checkedStrategy !== 'independent') {
        if (checkdChildrenLength === children.length) {
          state = TreeMapState.SELECTED;
        } else if (notCheckdChildrenLength === children.length) {
          state = state = TreeMapState.UNSELECTED;
        } else {
          state = TreeMapState.PARTIAL;
        }
      }

      var nodePathValue = nodePath.map(function (id) {
        return _this9.core.getItemInfo(id).value;
      });
      var propsValueContainsSelf;

      switch (this.core.checkedStrategy) {
        case 'child':
          {
            propsValueContainsSelf = this.value.includes(value) || children.some(function (child) {
              return _this9.value.includes(child.value);
            });
            break;
          }

        case 'parent':
          {
            propsValueContainsSelf = nodePathValue.some(function (item) {
              return _this9.value.includes(item);
            }) || children.some(function (child) {
              return _this9.value.includes(child.value);
            });
            break;
          }

        case 'all':
        case 'independent':
          {
            propsValueContainsSelf = this.value.includes(value);
          }
      }

      var allowdSetState = false;

      if (disabled || readonly) {
        if (propsValueContainsSelf && state !== TreeMapState.UNSELECTED) {
          allowdSetState = true;
        }
      } else {
        allowdSetState = true;
      }

      if (allowdSetState) {
        this.stateMap[id] = state;
      }
    }
  }]);

  return TreeMapValue;
}(Emitter);